import React from 'react'

export default props => (
  <svg viewBox="0 0 14 17" {...props}>
    <path d="M4,13 L10,13 L10,7 L14,7 L7,0 L0,7 L4,7 L4,13 Z M0,15 L14,15 L14,17 L0,17 L0,15 Z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/upload.js